import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import it from 'date-fns/locale/it';
import { useTranslation } from "react-i18next";

function DateRangePicker({
    extDateRange = [null, null],
    onDateRangePicked = () => { },
    minDaysNotice = null
}) {

    const [t, i18n] = useTranslation(["global"])

    const [dateRange, setDateRange] = useState(extDateRange);
    const [startDate, endDate] = dateRange; //deconstruction 

    const handleChange = (update) => {
        setDateRange(update)
        onDateRangePicked(update)
    }

    // Calcola la data minima basata su minDaysNotice

    const minSelectableDate = new Date();
    minSelectableDate.setDate(minSelectableDate.getDate() + minDaysNotice);



    return (
        <DatePicker
            className="form-control"
            showIcon
            placeholderText={t("helper.select_date")}
            dateFormat="dd/MM/yyyy"
            selectsRange={true}
            startDate={startDate}
            endDate={endDate}
            onChange={(update) => {
                handleChange(update);
            }}
            locale={it}
            monthsShown={2}
            withPortal
            minDate={minDaysNotice ? minSelectableDate : null} // Imposta la data minima
        />
    );
};

export default DateRangePicker